/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import FooterLinkList, { FooterLinkListProps } from "@/src/components/Footer/FooterLinkList.tsx";
import React from "react";

export type FooterLinkListLegalProps = Pick<FooterLinkListProps, "sx" | "title" | "spacing" | "direction">;
export default function FooterLinkListLegal({ title = "Rechtliches", ...footerLinkListProps  }: FooterLinkListLegalProps) {
  return (
    <FooterLinkList
      {...footerLinkListProps}
      title={title}
      links={[
        {
          to: "/agb",
          label: "AGB",
        },
        {
          to: "/datenschutz",
          label: "Datenschutz",
        },
        {
          to: "/impressum",
          label: "Impressum",
        },
        {
          to: "/barrierefreiheit",
          label: "Barrierefreiheit",
        },
      ]}
    />
  );
}
